module.exports = __webpack_public_path__ + "img/1.935540cf.png";